import { Department } from "../../../../domain/department";
import { IHisInformationApplicable, instanceOfIHisInformationApplicable } from "../../../../domain/document/items";
import { HisInformationTextValue } from "../../../../domain/his/HisInformationValue";
import { EditingDocument } from "../EditingDocument";

export class DepartmentHisObjectsUpdater {
  private readonly _updateTargetKeys: string[] = [
    "SRYKA_NAME",
    "SRYKA_SELECT",
  ];
  
  constructor(private _document: EditingDocument) {
  }

  public apply(department: Department): void {
    if (!department) { throw new Error("診療科が指定されていません。"); }

    for (let itemSetId = 0; itemSetId < this._document.itemSets.length; ++itemSetId) {
      const itemSet = this._document.itemSets[itemSetId];
      for (const item of itemSet.items) {
        if (!instanceOfIHisInformationApplicable(item) || !this.isUpdateTarget(item)) { continue; }
        const valueItem = new HisInformationTextValue(item.hisItemParameter.key, [department.name]);
        const cloned = item.clone() as IHisInformationApplicable;
        cloned.setHisInfoItems(valueItem, false);
        cloned.adjustObjectHeight();
        cloned.adjustFontSize();
        this._document.updateItem(cloned, {
          itemSetId,
        });
      }
    }
  }

  private isUpdateTarget(item: IHisInformationApplicable): boolean {
    return item.isEditable
      && !item.isDeleted
      && item.isHisInfo
      && item.hisItemParameter
      && this._updateTargetKeys.some(key => key === item.hisItemParameter.key);
  }
}
